import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { Source } from 'app/models/source.enum';
import { File } from 'app/models/file';
import { CompetitionService } from 'app/services/competition.service';
import { Document } from 'app/models/document';

@Injectable({
  providedIn: 'root'
})
export class OnboardingService {

  apiUrl: string = environment.api.url + environment.api.content.url;

  constructor(private http: HttpClient, private competitionService: CompetitionService) {}

  getAll(): Observable<Array<File>> {
    let params = new HttpParams();
    params = params.append('competition', this.competitionService.getCompetitionId());
    params = params.append('op', environment.api.content.type.assets.op);
    params = params.append('source', Source.Onboarding);

    return this.http
      .get<any>(this.apiUrl, { params })
      .pipe(
        map(res => res ? res.Items.map(el => <File>el) : []),
        catchError(err => throwError(err || 'ServerErr'))
      );
  }

  create(doc: Document): Observable<File> {
    const fileItem = new File(null, this.competitionService.getCompetitionId(),
                              doc.name, doc.displayName, doc.contentType,
                              doc.createdTime, new Date().getTime(), Source.Onboarding,
                              doc.id, doc.contentId);
    return this.http
      .post<File>(this.apiUrl, fileItem)
      .pipe(
        map(res => <File>res),
        catchError(err => throwError(err || 'ServerErr'))
      );
  }

  saveCoverPage(coverPage: File): Observable<File> {
    coverPage.updateDate = new Date().getTime();
    if (coverPage.id) {
      return this.http
        .put<File>(this.apiUrl, coverPage)
        .pipe(
          map(res => <File>res),
          catchError(err => throwError(err || 'ServerErr'))
        );
    } else {
      coverPage.parentId = this.competitionService.getCompetitionId();
      coverPage.coverPage = true;
      coverPage.createdTime = new Date().getTime();
      coverPage.source = Source.Onboarding;
      return this.http
        .post<File>(this.apiUrl, coverPage)
        .pipe(
          map(res => <File>res),
          catchError(err => throwError(err || 'ServerErr'))
        );

    }
  }

  remove(id: string): Observable<string> {
    let params = new HttpParams();
    params = params.append('op', environment.api.content.type.assets.op);
    params = params.append('element', id);

    return this.http
      .delete<string>(this.apiUrl, { params })
      .pipe(
        map(res => res as string),
        catchError(err => throwError(() => err || 'ServerErr'))
      );
  }
}
